/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */
import { USER } from '@/store/types';
import * as api from '@/api/user';
import { UserFull } from '@/api/types/user';

export interface StoreUserMatchesState {
  game: string;
  age: number;
  gender: number;
  constellation: number;
  users: UserFull[];
  index: number;
  point: number;
  noMore: boolean;
}

export default {
  namespaced: true,
  state: {
    game: null,
    age: null,
    gender: null,
    constellation: null,
    users: [],
    index: 0,
    point: null,
    noMore: false,
  },
  actions: {
    [USER.MATCHES_REQUEST]({ commit, state }, params) {
      if (params.game === void 0) {
        params.game = state.game;
      }
      if (params.age === void 0) {
        params.age = state.age;
      }
      if (params.gender === void 0) {
        params.gender = state.gender;
      }
      if (params.constellation === void 0) {
        params.constellation = state.constellation;
      }
      if (params.game !== state.game
        || params.gender !== state.gender
        || params.age !== state.age
        || params.constellation !== state.constellation
      ) {
        params.reload = true;
      }
      params.point = params.reload ? null : state.point;
      if (params.reload || params.next || state.users.length === 0) {
        return new Promise((resolve, reject) => {
          api.matchUser({
            game: params.game,
            age: params.age,
            gender: params.gender,
            constellation: params.constellation,
            point: params.point,
          }, params.silent).then((res) => {
            commit(USER.MATCHES_REQUEST, {
              reload: params.reload,
              game: params.game,
              age: params.age,
              gender: params.gender,
              constellation: params.constellation,
              users: res.data,
              point: res.extra.nextPoint,
            });
            resolve();
          }).catch(reject);
        });
      }
      return Promise.resolve();
    },
  },
  mutations: {
    [USER.MATCHES_REQUEST](state, { users, point, game, age, gender, constellation, reload }) {
      state.game = game;
      state.age = age;
      state.gender = gender;
      state.constellation = constellation;
      state.users = reload ? users : state.users.concat(users);
      state.index = reload ? 0 : state.index;
      state.point = point;
      state.noMore = point === 0 || users.length === 0;
    },
    [USER.MATCHES_SET_INDEX](state, index) {
      state.index = index;
    },
  },
};
